<template>
  <div class="news-preview">
    <div class="news-preview-content">
      <div class="text-group text-group-title">
        <h3 class="text-accent">
          {{ newsItem.date | formatDateDot}} &#124; {{ newsItem[$i18n.locale].label }}
          <template
            v-if="newsItem.type === 'media'"
          >
            &#124;
            <a
              class="text-accent"
              :href="newsItem.sourceUrl"
              target="_blank"
            >{{ newsItem.source }}</a>
          </template>
        </h3>
        <h2>{{ newsItem[$i18n.locale].title }}</h2>
        <!-- <p v-if="newsItem[$i18n.locale].subtitle">{{ newsItem[$i18n.locale].subtitle }}</p> -->
      </div>
      <!-- NEWS COVER -->
      <div
        class="news-preview-img-wrapper"
        :style="{ backgroundImage : `url('/uploads/${newsItem.cover}')`}"
      >
        <img class="news-preview-cover" :src="`${path}/${newsItem.cover}`" alt="Cover">
        <!-- IF THERE IS TEXT/QUOTE -->
        <div class="text-group" :class="{ 'text-group-quote' : false }">
          <p class="text-light">{{ newsItem[$i18n.locale].subtitle }}</p>
        </div>
      </div>
      <!-- PARAGRAPH 1 -->
      <div class="unreset news-preview-paragraph" v-html="newsItem[locale].contentOne"></div>
      <!-- GALLERY -->
      <div
        class="news-preview-gallery"
        v-if="newsItem.gallery.length"
        :class="{ 'news-preview-gallery-large': isGalleryLarge }"
      >
        <template v-for="(g, i) in newsItem.gallery">
          <transition :name="`show-${direction}`" :key="`transition-item-${i}`">
            <div
              v-if="activeGalleryItem === i"
              class="news-preview-gallery-item"
              :style="{ backgroundImage: `url('${path}/${g}')` }"
              :key="`gallery-item-${g}`"
              @click="isGalleryLarge = !isGalleryLarge"
            ></div>
          </transition>
        </template>
        <div class="news-preview-gallery-counter">
          <h2 class="text-light">
            <span class="kcm" @click="changeItem(activeGalleryItem - 1)">D</span>
            <span>{{activeGalleryItem + 1}}/{{newsItem.gallery.length}}</span>
            <span class="kcm" @click="changeItem(activeGalleryItem + 1)">B</span>
          </h2>
        </div>
      </div>
      <!-- PARAGRAPH 2 -->
      <div
        class="unreset news-preview-paragraph"
        v-if="newsItem[locale].contentTwo"
        v-html="newsItem[locale].contentTwo"
      ></div>
      <!-- END OF NEWS CONTENT -->
      <!-- <div class="news-preview-social">
        <p>{{ $t('news-preview-1') }}</p>
        <span class="social-btn" @click="shareToFacebook()">
          <svg
            aria-hidden="true"
            focusable="false"
            data-prefix="fab"
            data-icon="facebook-f"
            class="svg-inline--fa fa-facebook-f fa-w-9"
            role="img"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 264 512"
          >
            <path
              fill="#22075E"
              d="M215.8 85H264V3.6C255.7 2.5 227.1 0 193.8 0 124.3 0 76.7 42.4 76.7 120.3V192H0v91h76.7v229h94V283h73.6l11.7-91h-85.3v-62.7c0-26.3 7.3-44.3 45.1-44.3z"
            ></path>
          </svg>
        </span>
        <span class="social-btn" @click="shareToLinkedIn()">
          <svg
            aria-hidden="true"
            focusable="false"
            data-prefix="fab"
            data-icon="linkedin-in"
            class="svg-inline--fa fa-linkedin-in fa-w-14"
            role="img"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 448 512"
          >
            <path
              fill="#22075E"
              d="M100.28 448H7.4V148.9h92.88zM53.79 108.1C24.09 108.1 0 83.5 0 53.8a53.79 53.79 0 0 1 107.58 0c0 29.7-24.1 54.3-53.79 54.3zM447.9 448h-92.68V302.4c0-34.7-.7-79.2-48.29-79.2-48.29 0-55.69 37.7-55.69 76.7V448h-92.78V148.9h89.08v40.8h1.3c12.4-23.5 42.69-48.3 87.88-48.3 94 0 111.28 61.9 111.28 142.3V448z"
            ></path>
          </svg>
        </span>
      </div>-->
    </div>
    <SharedNews/>
  </div>
</template>

<script>
import SharedNews from '../shared/SharedNews';
export default {
  components: {
    SharedNews
  },
  data() {
    return {
      path: process.env.VUE_APP_UPLOADS_URI,
      isGalleryLarge: false,
      activeGalleryItem: 0,
      rotation: null,
      direction: 'right',
      interval: 8000,
      newsItem: {
        date: '',
        type: 'news',
        gallery: [],
        social: '',
        cover: '',
        bg: {
          title: '',
          subtitle: '',
          label: '',
          contentOne: '',
          contentTwo: ''
        },
        en: {
          title: '',
          subtitle: '',
          label: '',
          contentOne: '',
          contentTwo: ''
        }
      }
    };
  },
  computed: {
    locale() {
      return this.$i18n.locale;
    }
  },
  watch: {
    $route() {
      this.getNews();
    },
    "$i18n.locale"() {
      this.checkLang();
    }
  },
  methods: {
    startRotation() {
      this.rotation = setInterval(() => {
        this.direction = 'right';
        if (this.activeGalleryItem < this.newsItem.gallery.length - 1) {
          this.activeGalleryItem += 1;
        } else {
          this.activeGalleryItem = 0;
        }
      }, this.interval);
    },
    stopRotation() {
      clearInterval(this.rotation);
    },
    changeItem(n) {
      this.stopRotation();
      this.direction = this.activeGalleryItem < n ? 'right' : 'left';
      if (n < 0) {
        this.activeGalleryItem = this.newsItem.gallery.length - 1;
      } else if (n > this.newsItem.gallery.length - 1) {
        this.activeGalleryItem = 0;
      } else {
        this.activeGalleryItem = n;
      }
      this.startRotation();
    },
    shareToFacebook() {
      this.$snotify.warning('Споделянето е в процес на разработка');
    },
    shareToLinkedIn() {
      this.$snotify.warning('Споделянето е в процес на разработка');
    },
    checkLang() {
      if(!this.newsItem.en.title && this.$i18n.locale === 'en') {
        this.$i18n.locale = 'bg';
        localStorage.setItem('lang', this.$i18n.locale);
        this.$snotify.warning('There is no translation for this news');
      }
    },
    getNews() {
      this.$http
        .get(`${process.env.VUE_APP_BASE_URI}/news/${this.$route.query.id}`)
        .then(result => {
          this.newsItem = result.data;
          this.checkLang();
        })
        .catch(err => {
          console.log(err);
        });
    }
  },
  mounted() {
    this.getNews();
    this.startRotation();
  },
  destroyed() {
    this.stopRotation();
  }
};
</script>

<style lang="scss" scoped>
.news-preview {
  .news-preview-content {
    padding-left: $sidesPadding * 2;
    padding-right: $sidesPadding * 2;
    padding-top: $sidesPadding / 2;
    position: relative;
    .text-group-title {
      h2,
      p {
        margin: 15px 0;
      }
      h2 {
        font-family: 'Playfair Display';
        font-size: 36px;
        line-height: 42px;
        font-weight: 900;
      }
      h3 {
        a {
          opacity: 0.6;
        }
        a:hover {
          opacity: 0.8;
        }
      }
    }
    .news-preview-img-wrapper {
      margin: 25px 0;
      position: relative;
      width: 100%;
      .news-preview-cover {
        display: block;
        height: auto;
        width: 100%;
      }
      .text-group {
        background-color: rgba(22, 65, 148, 0.9);
        bottom: 20px;
        padding: 20px;
        position: absolute;
        right: -20px;
        width: 30%;
        p {
          margin: 0;
        }
      }
      .text-group-quote {
        padding-left: 60px;
        background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzNy45NDkiIGhlaWdodD0iMzAuMjYyIiB2aWV3Qm94PSIwIDAgMzcuOTQ5IDMwLjI2MiI+ICA8cGF0aCBpZD0iUGF0aF8yNjMyIiBkYXRhLW5hbWU9IlBhdGggMjYzMiIgZD0iTTIuNjE0LTQ0LjQwOCwxLjU3OS00Ni4xMTZxOC44LTQuNjU4LDguOC04LjgsMC0xLjc2LTMuMzEyLTMuNDY4QTEyLjI1NiwxMi4yNTYsMCwwLDEsMi45NS02MS40ODhhNi41NTQsNi41NTQsMCwwLDEtMS4xNjUtNC4wMzcsNy43MjYsNy43MjYsMCwwLDEsMi4zNTUtNS42NjcsNy42NjcsNy42NjcsMCwwLDEsNS42MTYtMi4zNTUsNy4wOTMsNy4wOTMsMCwwLDEsNS44NzUsMi45LDExLjk3LDExLjk3LDAsMCwxLDIuMjUxLDcuNTU3LDE3LjQ2OSwxNy40NjksMCwwLDEtNS44LDEzLjE0NiwyMi45NzUsMjIuOTc1LDAsMCwxLTMuODU2LDIuOTI0QTQ0LjM3Nyw0NC4zNzcsMCwwLDEsMi42MTQtNDQuNDA4Wm0tMjAuNDQ0LDAtMS4wMzUtMS43MDhxOC44LTQuNzEsOC44LTguOGEyLjQyMiwyLjQyMiwwLDAsMC0uNzI1LTEuNzM0LDEwLjc0OSwxMC43NDksMCwwLDAtMi41ODgtMS43MzQsMTEuNSwxMS41LDAsMCwxLTQuMDYzLTMuMDgsNi42MDUsNi42MDUsMCwwLDEtMS4yMTYtNC4wNjMsNy43NDUsNy43NDUsMCwwLDEsMi4zMjktNS42OTMsNy42MjQsNy42MjQsMCwwLDEsNS41OS0yLjMyOSw3LjE0Myw3LjE0MywwLDAsMSw1LjkyNiwyLjksMTEuOTcsMTEuOTcsMCwwLDEsMi4yNTEsNy41NTcsMTcuMzQ1LDE3LjM0NSwwLDAsMS0xLjQ3NSw3LjAzOSwxOC43NTgsMTguNzU4LDAsMCwxLTQuMzc0LDYuMTA3QTMwLjcwNSwzMC43MDUsMCwwLDEtMTcuODMxLTQ0LjQwOFoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE5LjU2NiA3NC4wNDgpIiBmaWxsPSIjZmZmIiBzdHJva2U9InJnYmEoMCwwLDAsMCkiIHN0cm9rZS13aWR0aD0iMSIvPjwvc3ZnPg==);
        background-repeat: no-repeat;
        background-position: 10px 20px;
        background-size: 40px;
      }
    }
    .news-preview-paragraph {
      margin: 0 auto;
      padding: 50px 0;
      width: 58vw;
    }
    .news-preview-gallery {
      align-items: flex-end;
      display: flex;
      height: 30.454vw;
      justify-content: flex-end;
      margin: 0 auto;
      position: relative;
      @include transition(all 0.6s $mainCubic);
      width: 58vw;
      .news-preview-gallery-item {
        cursor: zoom-in;
        background-color: #000;
        background-size: contain;
        background-position: center;
        background-repeat: no-repeat;
        height: 100%;
        left: 0;
        position: absolute;
        top: 0;
        width: 100%;
        z-index: 1;
      }
      .news-preview-gallery-counter {
        @extend %flex-center;
        background-color: $mainColor;
        position: relative;
        right: 1.25%;
        top: 15px;
        z-index: 2;
        @include transition(all 0.6s $mainCubic);
        h2 {
          align-items: center;
          display: inline-flex;
          font-size: 28px;
          line-height: 28px;
          span:nth-child(2) {
            display: inline-block;
            margin: 0 5px;
          }
          .kcm {
            cursor: pointer;
            display: inline-block;
            font-size: 24px;
            padding: 10px 5px;
            @include transition(all 0.3s $mainCubic);
          }
          .kcm:hover {
            background-color: rgba(255, 255, 255, 0.1);
          }
        }
      }
    }
    .news-preview-gallery::before {
      background-color: #b2c8d2;
      content: '';
      height: 70%;
      left: -2.5%;
      opacity: 0.5;
      position: absolute;
      top: 15%;
      width: 105%;
    }
    .news-preview-gallery::after {
      background-color: #b2c8d2;
      content: '';
      height: 85%;
      left: -1.25%;
      position: absolute;
      top: 7.5%;
      width: 102.5%;
    }
    .news-preview-gallery-large {
      height: 38.4vw;
      width: calc(98vw - 480px);
      .news-preview-gallery-item {
        cursor: zoom-out;
      }
    }
  }
  .news-preview-social {
    align-items: center;
    display: flex;
    justify-content: flex-end;
    p {
      font-weight: 500;
      margin-right: 20px;
    }
    .social-btn {
      align-items: center;
      background-color: #b2c8d2;
      border-radius: 50%;
      cursor: pointer;
      display: flex;
      height: 40px;
      justify-content: center;
      margin-left: 20px;
      @include transition(all 0.3s $mainCubic);
      width: 40px;
      svg {
        height: auto;
        height: 20px;
      }
    }
    .social-btn:hover {
      background-color: rgba(178, 200, 210, 0.8);
    }
  }
  .news-preview-content::after {
    background-color: #b2c8d2;
    bottom: -2%;
    content: '';
    -webkit-clip-path: polygon(0 0, 100% 0, 100% 100%, 20% 100%);
    clip-path: polygon(0 0, 100% 0, 100% 100%, 20% 100%);
    position: absolute;
    right: 0;
    height: 12%;
    opacity: 0.25;
    width: 50%;
    z-index: -1;
  }
}
@media screen and (max-width: 1600px) {
  .news-preview {
    .news-preview-content {
      padding-left: $sidesPadding1600 * 2;
      padding-right: $sidesPadding1600 * 2;
      padding-top: $sidesPadding1600 / 2;
      .news-preview-gallery-large {
        width: calc(98vw - 400px);
      }
    }
  }
}
@media screen and (max-width: 1280px) {
  .news-preview {
    .news-preview-content {
      padding-left: $sidesPadding1280 * 2;
      padding-right: $sidesPadding1280 * 2;
      padding-top: $sidesPadding1280 / 2;
      .news-preview-gallery-large {
        height: 45vw;
        width: calc(98vw - 160px);
      }
    }
  }
}
@media screen and (max-width: 1000px) {
  .news-preview {
    .news-preview-content {
      padding-top: $sidesPadding1280;
      .text-group-title {
        h3 {
          font-size: 10px;
          margin-bottom: 0;
        }
        h2 {
          font-size: 24px;
          line-height: 28px;
          margin: 10px 0;
        }
      }
      .news-preview-img-wrapper {
        .text-group {
          padding: 15px;
          width: 50%;
          p {
            line-height: 14px;
          }
        }
      }
      .news-preview-paragraph {
        padding: 30px 0;
        width: 100%;
      }
      .news-preview-gallery,
      .news-preview-gallery-large {
        height: 43vw;
        width: 100%;
      }
    }
  }
}
@media screen and (max-width: 800px) {
  .news-preview {
    .news-preview-content {
      .news-preview-paragraph {
        width: 100%;
      }
      .news-preview-gallery,
      .news-preview-gallery-large {
        height: 40vw;
      }
    }
  }
}
@media screen and (max-width: 600px) {
  .news-preview {
    .news-preview-content {
      padding: $sidesPadding600;
      .text-group-title {
        h3 {
          font-size: 9px;
        }
        h2 {
          font-size: 17px;
          line-height: 22px;
          margin: 5px 0;
        }
      }
      .news-preview-img-wrapper {
        .text-group {
          padding: 10px;
          right: -10px;
          width: 80%;
          p {
            line-height: 12px;
            font-size: 10px;
          }
        }
      }
      .news-preview-gallery {
        margin: 15px auto;
        height: 25vh;
      }
      .news-preview-gallery,
      .news-preview-gallery-large {
        height: 50vw;
      }
      .news-preview-paragraph {
        padding: 20px 0;
        width: 100%;
      }
    }
  }
}
</style>

